<template>
    <div id="grid-vue">
        <table class="bordered striped">
            <thead>
                <tr>
                    <th v-for="key in columns"
                        v-if="key != 'id'"
                        @click="sortBy(key)"
                        :class="{ active: sortKey == key }" :data-key="key.toUpperCase()">

                        <span>{{ key.toUpperCase() | capitalize }}</span>

                        <span v-if="showOrder" class="arrow" :class="sortOrders[key] > 0 ? 'asc' : 'dsc'"></span>
                    </th>
                    <th class="center" v-if="checkShowAcoes()" data-key="ACOES">Ações</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="entry in filteredData" :id="'item-'+entry['id']">
                    <td v-for="key in columns" v-if="key != 'id'">
                        {{entry[key]}}
                    </td>
                    <td class="center" v-if="checkShowAcoes()">
                        <router-link v-if="checkEditar()" :to="editar+entry['id']" v-tooltip.bottom="'Editar'" class="text-default">
                            <i class="material-icons text-default">mode_edit</i>
                        </router-link>
                        <botao-remover :identificador="entry['id']" v-if="checkDeletar()" :url="deletar+entry['id']" @deleted="() => $emit('deleted', {item: entry})"></botao-remover>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<style>
    #grid-vue .btn-flat:hover,
    #grid-vue .btn-flat:active{
        background: transparent;
    }
    #grid-vue th.active {
        text-decoration: underline;
    }

    #grid-vue th.active .arrow {
        opacity: 1;
    }

    #grid-vue .arrow {
        display: inline-block;
        vertical-align: middle;
        width: 0;
        height: 0;
        margin-left: 5px;
        opacity: 0.66;
    }

    #grid-vue .arrow.asc {
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        border-bottom: 4px solid #000;
    }

    #grid-vue .arrow.dsc {
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        border-top: 4px solid #000;
    }
</style>
<script>
    import BotaoRemover from '@/components/common/BotaoRemover';

  export default {
      components: {
          BotaoRemover
      },
      props: {
          data: Array,
          columns: Array,
          filterKey: String,
          deletar: {
              type: String,
              default: '',
          },
          showOrder:{
              type: Boolean,
              default: true
          },
          editar: {
              type: String,
              default: '',
          }
      },
      data: function () {
          let sortOrders = {};
          this.columns.forEach(function (key) {
              sortOrders[key] = 1
          });
          return {
              sortKey: '',
              sortOrders: sortOrders
          }
      },
      computed: {
          filteredData: function () {
              let sortKey = this.sortKey;
              let filterKey = this.filterKey && this.filterKey.toLowerCase();
              let order = this.sortOrders[sortKey] || 1;
              let data = this.data;
              if (filterKey) {
                  data = data.filter(function (row) {
                      return Object.keys(row).some(function (key) {
                          return String(row[key]).toLowerCase().indexOf(filterKey) > -1;
                      })
                  })
              }
              if (sortKey) {
                  data = data.slice().sort(function (a, b) {
                      a = a[sortKey];
                      b = b[sortKey];
                      return (a === b ? 0 : a > b ? 1 : -1) * order;
                  })
              }
              return data;
          }
      },
      filters: {
          capitalize: function (str) {
              return str.charAt(0).toUpperCase() + str.slice(1);
          }
      },
      methods: {
          sortBy: function (key) {
              this.sortKey = key;
              this.sortOrders[key] = this.sortOrders[key] * -1;
          },
          checkShowAcoes() {
              return this.deletar !== '' || this.editar !== '';
          },
          checkEditar() {
              return this.editar !== '';
          },
          checkDeletar() {
              return this.deletar !== '';
          }
      }
  }
</script>



// WEBPACK FOOTER //
// src/components/common/Grid.vue